module.exports = __webpack_public_path__ + "client/styles/fonts/SourceSansPro-Bold.ttf";


//////////////////
// WEBPACK FOOTER
// ./client/styles/fonts/SourceSansPro-Bold.ttf
// module id = 1485
// module chunks = 0